// extracted by mini-css-extract-plugin
module.exports = {"product-diagram-title":"product-diagram-title_product-diagram-title__oWMni"};